<!-- your-component.component.html -->
<div class="side-nav">
    <ul class="nav flex-column">
        <!-- Main Menu: Planning -->
        <li class="nav-item">
            <a class="nav-link" routerLink="/main/roasters/generalSettings">
              <span class="me-3"><i class="fa-solid fa-gear"></i></span>General Setting
            </a>
        </li>
        <li class="nav-item">
            <a class="nav-link iconWhite" (click)="toggleSpocMenu('rosterPlan')" [class.active]="isRosterPlanMenuActive">
                <span class="me-2"><i class="fa-solid fa-medal"></i></span>
                <span >Planning</span> <i class="fas fa-chevron-down float-end" [ngClass]="{'rotate': !isRosterPlanOpen}"></i>
            </a>
            <!-- Submenu: SPOC -->
            <ul class="collapse submenu" [ngClass]="{'show': isRosterPlanOpen}">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/main/roasters/rosterPlan">  <span class="me-2"><i class="fa-solid fa-calendar-days"></i></span>Rostering</a>
                </li>
               
            </ul>
        </li>
        <!-- Main Menu: Request & Approval -->
        <li class="nav-item">
            <a class="nav-link iconWhite" (click)="toggleSpocMenu('roster')" [class.active]="isRosterMenuActive">
                <span class="me-2"><i class="fa-solid fa-users"></i></span>
                <span > Request & Approval</span> <i class="fas fa-chevron-down float-end" [ngClass]="{'rotate': !isRosterOpen}"></i>
            </a>
            <!-- Submenu: SPOC -->
            <ul class="collapse submenu" [ngClass]="{'show': isRosterOpen}">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/main/roasters/selfRoaster">Self Roastering</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" routerLink="/main/roasters/adhoc">Adhoc Roster Requests</a>
                </li>
            </ul>
        </li>
        <!-- Main Menu: SPOC -->
        <li class="nav-item iconWhite">
            <a class="nav-link iconWhite" (click)="toggleSpocMenu('spoc')" [class.active]="isSpocMenuActive">
                <span class="me-2"> <i class="fa-solid fa-id-card" ></i></span>
                <span >SPOC</span> <i class="fas fa-chevron-down float-end" [ngClass]="{'rotate': !isSpocMenuOpen}"></i>
            </a>
            <!-- Submenu: SPOC -->
            <ul class="collapse submenu" [ngClass]="{'show': isSpocMenuOpen}">
                <li class="nav-item">
                    <a class="nav-link" routerLink="/main/roasters/teams">Form Team</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Roaster Team Assigned</a>
                </li>
            </ul>
        </li>
    </ul>
</div>
<div class="content">
 <router-outlet></router-outlet>
</div>


